import type { Cart } from "./Cart.js";

export function isCartEmpty(cart: Cart): boolean {
	return cart.order.products.length === 0 && cart.order.vouchers.length === 0;
}
